import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol } from "@ionic/react";
import React from "react";
import Masonry from 'react-masonry-component';
import './Feeds.css';

interface Props {
    feeds: any
}

const Feeds: React.FC<Props> = (props) => {


    const Cards = () => {
        if (props.feeds) {
            return (
                props.feeds.map((feed: any, key: any) => (
                    <IonCol sizeXs="12" sizeSm="6" sizeMd="4" key={key} className="feeditem">
                        <IonCard routerLink={`../account/feeds/${feed.id}`} >
                            <IonCardHeader>
                                <CardImg feed={feed} ></CardImg>
                                {!feed._embedded['wp:term'] [0][0]? <></> :
                                    <p>{feed._embedded['wp:term'][0][0].name}</p>
                                }
                                <IonCardTitle dangerouslySetInnerHTML={{__html:feed.title.rendered}}></IonCardTitle>
                            </IonCardHeader>

                            <IonCardContent dangerouslySetInnerHTML={{ __html: feed.excerpt.rendered }}>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>

                ))


            )
        } else {
            return (<></>)
        }

    }


    interface ImgProps {
        feed: any
    }
    const CardImg = (imgprop: ImgProps) => {
        if (imgprop.feed._embedded['wp:featuredmedia']) {
            return (
                <img src={imgprop.feed._embedded['wp:featuredmedia'][0].source_url}></img>
            )
        } else { return <></> }
    }

    const WithMason = () => {
        if (props.feeds) {
            return (
                <Masonry

                    className={'my-gallery-class'}
                    disableImagesLoaded={false} // default false
                    updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                >
                    <Cards />
                </Masonry>
            )
        } else {
            return <></>;
        }
    }

    return (
        <WithMason></WithMason>

    );
}

export default Feeds;